import utils from '@/libs/utils/utils'
import jsBridge from '@/libs/jsBridge'

/**
 * 此文件内的方法用途为获取一些基础信息并且挂载到window节点下
 * tip：能少加尽量少加，只挂载常用信息，不要乱用
 */

/**
 * 获取app提供的设备信息
 */
export function getReportInfo () {
  // console.log('global:window.dataReport', window.dataReport)
  if (jsBridge.ishaveNativeMethod('getReportInfo') || window.h5bridge || window.dataReport) {
    let reportInfo = jsBridge.getReportInfo()
    reportInfo = JSON.parse(reportInfo)
    if(reportInfo) {
      let appVersion = Number(reportInfo.appVersion)
      window.appVersion = appVersion
      window.reportInfo = reportInfo
    }
    // console.log('app版本信息：', appVersion)
    // console.log('app信息', reportInfo)
  } else {
    window.appVersion = 0
    // console.log('无法获取app版本信息')
    window.reportInfo = undefined
  }
}

//获取token
window.token = utils.getToken()
// console.log('GOFUNAUTHORIZATION', window.token)
//获取app提供的设备信息
getReportInfo()



// WEBPACK FOOTER //
// src/libs/global.js